import { render, staticRenderFns } from "./AcessoNegado.vue?vue&type=template&id=87321fbc"
var script = {}
import style0 from "./AcessoNegado.vue?vue&type=style&index=0&id=87321fbc&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87321fbc')) {
      api.createRecord('87321fbc', component.options)
    } else {
      api.reload('87321fbc', component.options)
    }
    module.hot.accept("./AcessoNegado.vue?vue&type=template&id=87321fbc", function () {
      api.rerender('87321fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AcessoNegado.vue"
export default component.exports